import { createContext, HTMLProps, ReactNode, useContext, useMemo, useState } from "react";

import Button from "@ntemarked/mittne-components/dist/Button/Button";

import Modal from "components/molecules/Modal";
import Portal from "components/organisms/Portal";

type ModalButtonContextType = {
	close: () => void;
};

const ModalButtonContext = createContext<ModalButtonContextType>({
	close: () => {
		throw new Error("ModalButtonContext: close was called without a Provider");
	},
});

export const useModalButtonContext = () => {
	return useContext(ModalButtonContext);
};

type ModalButtonProps = Omit<HTMLProps<HTMLButtonElement>, "type" | "onClick" | "label"> & {
	children: ReactNode;
	label?: string;
	icon?: ReactNode;
};
export default function ModalButton(props: ModalButtonProps) {
	const [isOpen, setIsOpen] = useState(false);
	const { children, label, icon, ...rest } = props;

	const contextValue = useMemo(() => {
		return {
			close: () => {
				setIsOpen(false);
			},
		};
	}, [setIsOpen]);

	return (
		<>
			<Button
				type="button"
				onClick={(e) => {
					e.stopPropagation();
					setIsOpen(!isOpen);
				}}
				{...rest}
				label={label}
				icon={icon}
			/>
			<Portal>
				{isOpen && (
					<ModalButtonContext.Provider value={contextValue}>
						<Modal onClose={() => setIsOpen(false)}>{children}</Modal>
					</ModalButtonContext.Provider>
				)}
			</Portal>
		</>
	);
}
